import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { PendingRequestsContext } from '../../utils/apiPendingRequests'

const LeaveConfirmationPrompt = () => {
  const { t } = useTranslation()
  const { pendingRequests } = useContext(PendingRequestsContext)

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Most of the modern browsers don't show the message anymore
      const message = t('Are you sure you want to leave?')

      // eslint-disable-next-line no-param-reassign
      event.returnValue = message
      return message
    }

    // Add the event listener when there are pending requests
    if (pendingRequests > 0) {
      window.addEventListener('beforeunload', handleBeforeUnload)
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload)
      }
    }

    // Remove the event listener when there are no pending requests
    window.removeEventListener('beforeunload', handleBeforeUnload)
    return undefined
  }, [t, pendingRequests])

  return null
}

export default LeaveConfirmationPrompt
